import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {};

export const stack: SxStyle = {
  borderWidth: 1,
  borderStyle: 'solid',
  borderColor: (p) => p.palette.grey[300],
  borderRadius: (p) => p.spacing(1),
  padding: (p) => p.spacing(1, 1.5),
};
